// extracted by mini-css-extract-plugin
export default {"switcherWrapper":"styles_switcherWrapper__XN6M4"};